import { SanitizeHTMLString } from "@circle-react-shared/uikit/SanitizeContent";
import { Loader } from "@circle-react-uikit/Loader";
import { Modal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";

import { useSpacesLimitAddonState } from "./useSpacesLimitAddonState";

interface SpacesLimitAddonModalComponentProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const SpacesLimitAddonModalComponent = ({
  open,
  onOpenChange,
}: SpacesLimitAddonModalComponentProps) => {
  const {
    addon,
    isLoading,
    isSubmitting,
    handleConfirm,
    buildDescription,
    i18nRoot,
  } = useSpacesLimitAddonState(() => onOpenChange(false));

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange}>
      <Modal.Content>
        <Modal.Header title={t(`${i18nRoot}.title`)} />
        <Modal.Body>
          {isLoading ? (
            <Loader center />
          ) : (
            <SanitizeHTMLString content={buildDescription()} />
          )}
        </Modal.Body>
        <Modal.Footer
          secondaryAction={{
            label: t("cancel"),
            onClick: () => onOpenChange(false),
          }}
          primaryAction={{
            label: t(`${i18nRoot}.confirm`),
            onClick: () => void handleConfirm(),
            loading: isSubmitting,
            disabled: isLoading || !addon,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
